import { render, staticRenderFns } from "./editAllocationStorehouseApplyList.vue?vue&type=template&id=8d127bcc&scoped=true"
import script from "./editAllocationStorehouseApplyList.vue?vue&type=script&lang=js"
export * from "./editAllocationStorehouseApplyList.vue?vue&type=script&lang=js"
import style0 from "./editAllocationStorehouseApplyList.vue?vue&type=style&index=0&id=8d127bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d127bcc",
  null
  
)

export default component.exports